import { track } from '@tldraw/tldraw'
import { ItalicProps } from './Types'
import { Italic as Icon } from 'blaze-ui/icons'
import { useUpdateStyle } from '../VisualEditor/hooks/useUpdateStyle'
import { ItalicStyle } from '../VisualEditor/StyleProps'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { observer } from 'mobx-react-lite'
import { Button } from 'common/Prose/Toolbar/ToolbarBravo/WriterFormatToolbar/Button'
import { useAvailableItalic } from '../VisualEditor/hooks/useAvailableItalic'

const Italic = track(
  observer(({ editor, fontWeightStyle, fontFamilyStyle, italicStyle, tooltipPlacement }: ItalicProps) => {
    const updateStyle = useUpdateStyle(editor)
    const availableItalic = useAvailableItalic(fontFamilyStyle, fontWeightStyle)

    const isDisabled = fontWeightStyle.type === 'mixed' || !availableItalic
    const isToggled = italicStyle.type === 'shared' && italicStyle.value

    return (
      <Tooltip label="Italic" placement={tooltipPlacement}>
        <Button
          isDisabled={isDisabled}
          variant={isToggled ? 'squareToggleOn' : 'squareToggleOff'}
          onPress={() => updateStyle(ItalicStyle, !isToggled)}
          aria-label="Italic"
          icon={() => <Icon size={20} />}
        />
      </Tooltip>
    )
  }),
)

export { Italic }
